import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useDonationsStore } from '../store/donationsStore'
import { updateDonation } from '../utils/updateDonation'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useUpdateDonationMutation = (onSuccess?: () => void) => {
  const update = useDonationsStore((state) => state.update)

  return useMutation({
    mutationFn: updateDonation,
    onSuccess: ({ message, donation }) => {
      update(donation)

      toast.success(message || 'Donation edited successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while editing donation.')
    },
  })
}
